import { EstimateAndQuoteDetailViewModel } from '@models/EstimateAndQuoteDetail';

export const calculateDiscountAmount = (
  estimateDetails: EstimateAndQuoteDetailViewModel[],
  discount: number,
  discountType?: number
): number => {
  const subtotal = estimateDetails.reduce((acc, cur) => acc + cur.subTotal, 0);
  const taxAmount = estimateDetails
    .map((o) =>
      o.estimateDetailSalesTaxes.reduce(
        (acc, cur) => acc + cur.salesTaxAmount,
        0
      )
    )
    .reduce((acc, cur) => acc + cur, 0);

  if (discountType === 2) {
    // Percentage
    return ((subtotal + taxAmount) * discount) / 100;
  }
  // Amount (default)
  return discount;
};
